import { LoadStateInitialValue } from 'app/core/interfaces/generic.interface';
import { CustomerPermissions } from 'app/core/store/session/customer-permissions/customer-permissions.interface';

export const INITIAL_STATE_CUSTOMER_PERMISSIONS = new LoadStateInitialValue<CustomerPermissions>({
  createOrUpdateFlow: [],
  queryOrGetFlow: [],
  createOrUpdateOrder: [],
  queryOrGetOrder: [],
  invoices: [],
  blankReceipts: [],
  acceptFlow: [],
  calenderLegend: [],
});
